import { api } from './client';
import { API_BASE_URL } from '../config/api';

/**
 * @param {{
 *   token: string,
 *   body: Record<string, unknown>,
 * }} params
 */
export async function createOrder({ token, body }) {
  const { data } = await api.post(`${API_BASE_URL}/orders/`, body, {
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
    timeoutMs: 45000,
  });
  return parseCreateOrderResponse(data);
}

/**
 * Mint a fresh Razorpay order id for an existing Payment Pending order (resume payment).
 * @param {{ token: string, orderNumber: string }} params
 */
export async function initiateRazorpayPaymentForOrder({ token, orderNumber }) {
  const { data } = await api.post(
    `${API_BASE_URL}/orders/initiateRazorpayPayment/${encodeURIComponent(orderNumber)}`,
    {},
    {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
      timeoutMs: 45000,
    },
  );
  return parseCreateOrderResponse(data);
}

/**
 * Cancel an unpaid Payment Pending order (customer self-service).
 * @param {{ token: string, orderNumber: string }} params
 */
export async function cancelPendingOrder({ token, orderNumber }) {
  const { data } = await api.post(
    `${API_BASE_URL}/orders/cancelPendingOrder/${encodeURIComponent(orderNumber)}`,
    {},
    {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
      timeoutMs: 30000,
    },
  );
  return data;
}

/**
 * @param {unknown} data
 */
export function parseCreateOrderResponse(data) {
  const root = data && typeof data === 'object' ? /** @type {Record<string, unknown>} */ (data) : {};
  const inner = root.data && typeof root.data === 'object' ? /** @type {Record<string, unknown>} */ (root.data) : {};

  const orderId = inner.id != null ? String(inner.id) : null;
  const orderNumber =
    typeof inner.orderNumber === 'string'
      ? inner.orderNumber
      : inner.orderNumber != null
        ? String(inner.orderNumber)
        : null;

  const rzpOrderID =
    typeof root.rzpOrderID === 'string'
      ? root.rzpOrderID
      : root.rzpOrderID != null
        ? String(root.rzpOrderID)
        : null;

  const rzpKeyId =
    typeof root.rzpKeyId === 'string'
      ? root.rzpKeyId
      : root.rzpKeyId != null
        ? String(root.rzpKeyId)
        : null;

  return {
    orderId,
    orderNumber,
    rzpOrderID,
    rzpKeyId,
    raw: root,
  };
}

/**
 * @param {{
 *   token: string,
 *   orderNumber: string,
 *   rzpOrderID: string,
 *   rzpPaymentId: string,
 *   razorpaySignature: string,
 * }} params
 */
export async function verifyRazorpayPayment({
  token,
  orderNumber,
  rzpOrderID,
  rzpPaymentId,
  razorpaySignature,
  paymentMethod,
}) {
  const params = new URLSearchParams({
    rzpOrderID,
    rzpPaymentId,
    razorpay_signature: razorpaySignature,
  });
  if (paymentMethod) {
    params.set('paymentMethod', paymentMethod);
  }

  const { data } = await api.get(
    `${API_BASE_URL}/orders/handleRzpResponseMobile/${encodeURIComponent(orderNumber)}?${params.toString()}`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
      timeoutMs: 30000,
    },
  );

  return data;
}
